import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { SpotifyLogo } from '@phosphor-icons/react';

export default function SpotifyCallback() {
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !state) { navigate('/connections'); return; }
    (async () => {
      try {
        await api.post('/spotify/callback', { code, state });
        toast.success('Spotify connected — ready to import your catalog');
        navigate('/connections');
      } catch (e) {
        toast.error(e.response?.data?.detail || 'Spotify connect failed');
        navigate('/connections');
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <div className="text-center">
        <SpotifyLogo size={40} weight="fill" className="text-[#1DB954] mx-auto animate-pulse" />
        <p className="mt-4 text-sm font-mono text-zinc-400">Connecting Spotify…</p>
      </div>
    </div>
  );
}
